<template>
  <v-row>
    <v-col
      v-if="arrayVazio"
      class="text-subtitle-1 text-center"
      :class="arrayVazio ? 'mt-12' : ''"

      cols="12"
    >
      Sem dados para gerar relatório
    </v-col>
    <v-col
      v-if="loading"
      class="text-subtitle-1 text-center"
      :class="loading ? 'mt-12' : ''"
      cols="12"
    >
      Carregando . . .
    </v-col>
    <v-col
      cols="6"
      class="mx-auto"
      :class="!loading ? 'd-none' : ''"
    >
      <v-progress-linear
        v-if="loading"
        style="min-height: 10px"
        indeterminate
        rounded
      ></v-progress-linear>
    </v-col>
    <v-col
      v-for="(item, index) in relatorioData"
      :key="index"
      cols="12"
      :md="6"
      :class="loading ? 'd-none' : ''"
      class="py-2"
    >
      <v-card
        v-if="!loading"
        elevation="3"
        class="pa-0"
      >
        <div class="py-4 px-4 d-flex justify-space-between ">
          <div class="d-block align-center ">
            <span class="text--primary font-weight-bold text-xl">
              Fila: {{ item.fila }}
            </span>
          </div>

          <div class="d-block align-center ">
            <span class="text--primary font-weight-bold text-xl">
              Protocolo: {{ item.protocolo }}
            </span>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-text class="py-4 px-4">
          <div class="invoice-header d-flex flex-wrap justify-space-between flex-column flex-sm-row">
            <div class="mb-8 mb-sm-0">
              <span class="d-block">Agente: {{ item.agente }}</span>
              <span class="d-block">Abertura: {{ formatDate(item.dataAbertura) }}</span>
              <span class="d-block">Fechamento: {{ formatDate(item.dataFechamento) }}</span>
              <span class="d-block">Tempo de atendimento: {{ item.tempoTotalAtendimento }}</span>
              <span class="d-block">Canal: {{ item.canal }}</span>
              <span class="d-block">TPR: {{ item.tempoDePrimeiraResposta }}</span>
              <span class="d-block">Mensagens (Atendente/Cliente): {{ item.quantidadeMensagensAtendente }}/{{ item.quantidadeMensagensCliente }}</span>
            </div>
            <div>
              <span class="d-block">E-mail: {{ item.emailCliente }}</span>
              <span class="d-block">Tipo de Solicitação: {{ item.tipoSolicitacao }}</span>
              <span class="d-block">Cliente: {{ item.nomeCliente }}</span>
              <span class="d-block">Celular: {{ item.celularCliente }}</span>
               <span class="d-block">TMER: {{ item.tempoMedioEntreRespostas }}</span>
              <span class="d-block">Total de Mensagens: {{ item.quantidadeMensagens }}</span>
            </div>
          </div>
        </v-card-text>
        <div class="px-4 pb-2 d-flex justify-end bg-surface-variant">
          <v-chip
            small
            outlined
            :color="colors(item.nomeStatus)"
            class="v-chip-light-bg font-weight-semibold"
            :class="`${colors(item.nomeStatus)}--text`"
          >
            {{ item.nomeStatus }}
          </v-chip>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPlusBoxMultiple, mdiClockTimeEightOutline, mdiStopCircleOutline, mdiAccount } from '@mdi/js'
import { computed } from '@vue/composition-api'

export default {
  props: {
    relatorioData: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    arrayVazio: {
      type: Boolean,
      default: false,
    },

  },

  setup() {
    const formatDate = date => {
      if (!date) return null
      const dates = date.split('T')
      const [year, month, day] = dates[0].split('-')
      return `${day}/${month}/${year}`
    }
    const dateFormatted = computed(() => formatDate())

    const colors = value => {
      if (value === 'Andamento') return 'accent'
      if (value === 'Novo') return 'success'
      if (value === 'Finalizado') return 'error'
      if (value === 'Resolvido') return 'warning'
      if (value === 'Pendente') return 'secundary'

      return 'success'
    }

    return {
      formatDate,
      colors,
      dateFormatted,

      // icons
      icons: {
        mdiStopCircleOutline,
        mdiPlusBoxMultiple,
        mdiClockTimeEightOutline,
        mdiAccount,
      },
    }
  },
}
</script>
